package org.dronda.app.web.client

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import org.dronda.api.wishlist.AddParticipantRequest
import org.dronda.api.wishlist.ApiError
import org.dronda.api.wishlist.CreateEventResponse
import org.dronda.api.wishlist.Event
import org.dronda.api.wishlist.EventAdminState
import org.dronda.api.wishlist.EventRequest
import org.dronda.api.wishlist.EventWithWishLists
import org.dronda.api.wishlist.SendAssignmentsRequest
import org.dronda.api.wishlist.SendAssignmentsResponse
import org.dronda.api.wishlist.SendKind
import org.dronda.api.wishlist.UpdateEventRequest
import org.dronda.api.wishlist.UpdateExclusionsRequest
import org.dronda.api.wishlist.User

class EventClient(private val client: HttpClient) {

    suspend fun getEvents(): Result<List<Event>, Unit> {
        val response = client.get("/wl/events")

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }

    suspend fun getEvent(eventId: String): Result<EventWithWishLists, Unit> {
        val response = client.get("/wl/event/$eventId")

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }

    suspend fun createEvent(request: EventRequest): Result<CreateEventResponse, Unit> {
        val response = client.post("/wl/event") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }

    suspend fun updateEvent(eventId: String, request: UpdateEventRequest): Result<Event, String> {
        return client.put("/wl/event/$eventId") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.toResult()
    }

    suspend fun addParticipant(eventId: String, email: String): Result<User, String> {
        return client.post("/wl/event/$eventId/participant") {
            contentType(ContentType.Application.Json)
            setBody(AddParticipantRequest(email))
        }.toResult()
    }

    suspend fun getAdminState(eventId: String): Result<EventAdminState, String> {
        return client.get("/wl/event/$eventId/admin").toResult()
    }

    suspend fun updateExclusions(eventId: String, request: UpdateExclusionsRequest): Result<EventAdminState, String> {
        return client.put("/wl/event/$eventId/exclusions") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.toResult()
    }

    suspend fun sendAssignments(eventId: String, kind: SendKind): Result<SendAssignmentsResponse, String> {
        return client.post("/wl/event/$eventId/santa/send") {
            contentType(ContentType.Application.Json)
            setBody(SendAssignmentsRequest(kind))
        }.toResult()
    }

    private suspend inline fun <reified T> HttpResponse.toResult(): Result<T, String> {
        return if (status == HttpStatusCode.OK) {
            Ok(body())
        } else {
            val message = runCatching { body<ApiError>().message }.getOrNull()
            Err(message?.takeIf { it.isNotBlank() } ?: "Something went wrong. Please try again.")
        }
    }
}
